interface ToastOptions {
  message: string
  duration?: number
}

export function useToast() {
  const timerId = useState<NodeJS.Timeout | undefined>('timerId', () => undefined)

  const showToast = (options: ToastOptions) => {
    clearTimeout(timerId.value)
    const $nuxt = document.querySelector('#__nuxt')

    const toastContainerId = 'toast-container'
    const toastId = 'toast'

    const $toastContainer: HTMLDivElement
      = document.querySelector(`#${toastContainerId}`) ?? document.createElement('div')
    $toastContainer.id = toastContainerId
    $toastContainer.style.position = 'fixed'
    $toastContainer.style.bottom = '0'
    $toastContainer.style.left = '0'
    $toastContainer.style.right = '0'

    const $toast: HTMLDivElement
      = document.querySelector(`#${toastId}`) ?? document.createElement('div')
    $toast.id = toastId
    $toast.style.cssText
      = 'display:block; position:fixed; left:20px; right:20px; bottom:30px; margin:0 auto; width:fit-content; max-width:700px; text-align:center; background-color:rgba(0,0,0,0.7); border-radius:100px; padding:12px 30px; color:#FFF; font-size:14px; line-height:1.6; z-index:100; -webkit-backdrop-filter:blur(10px); backdrop-filter:blur(10px)'
    $toast.style.transition = 'opacity 0.25s ease-in-out'
    $toast.style.opacity = '0'
    $toast.innerHTML = options.message

    $nuxt?.appendChild($toastContainer)
    $toastContainer.appendChild($toast)

    setTimeout(() => {
      $toast.style.opacity = '1'
    }, 100)

    timerId.value = setTimeout(() => {
      $toast.style.opacity = '0'
      setTimeout(() => {
        $toast.remove()
      }, 250)
    }, options.duration ?? 1500)
  }

  return { showToast }
}
